<template>
  <div>
    <div :class="['BINGO_container', 'BINGO_header','pt-4','my-4']">
      <span :class="['bingoLetter']">B</span>
      <span :class="['bingoLetter']">I</span>
      <span :class="['bingoLetter']">N</span>
      <span :class="['bingoLetter']">G</span>
      <span :class="['bingoLetter']">O</span>
    </div>
    <PlayerNameField />
    <CreateRoom />
    <JoinRoom />
    <RoomList />
  </div>
</template>
<script>
import CreateRoom from "@/components/CreateRoom.vue";
import JoinRoom from "@/components/JoinRoom.vue";
import RoomList from "@/components/RoomList.vue";
import PlayerNameField from "@/components/PlayerNameField.vue";
import Server from "@/server";
import store from "@/store";
import Emoji from "@/components/svg/Emoji";

export default {
  components: {
    CreateRoom,
    JoinRoom,
    RoomList,
    PlayerNameField
  },
  mounted: function() {
    store.state.mainRoomLoaded = true;
    clearInterval(store.state.timer);
    store.state.room.elapsedTime = 0;
    Server.updateRoomList();
  }
};
</script>
